"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DiscountDetails = _interopRequireDefault(require("../DiscountDetails/DiscountDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LineItemDiscounts = function LineItemDiscounts(_ref) {
  var item = _ref.item,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DiscountDetails["default"], {
    type: "promotion",
    className: className,
    discounts: item.discount.discounts,
    formattedTotalValue: item.discount.formattedTotalValue
  }), /*#__PURE__*/_react["default"].createElement(_DiscountDetails["default"], {
    type: "rebate",
    className: className,
    discounts: item.rebatesApplied.rebates,
    formattedTotalValue: item.rebatesApplied.formattedTotalValue
  }), item.options.map(function (_ref2) {
    var addOn = _ref2.addOn,
        rebatesApplied = _ref2.rebatesApplied;
    return addOn && rebatesApplied.visible && /*#__PURE__*/_react["default"].createElement(_DiscountDetails["default"], {
      type: addOn.type,
      key: addOn.id,
      className: className,
      discounts: rebatesApplied.rebates,
      formattedTotalValue: rebatesApplied.formattedTotalValue
    });
  }));
};

LineItemDiscounts.propTypes = {
  item: _propTypes["default"].shape({
    discount: _propTypes["default"].shape({
      discounts: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
      formattedTotalValue: _propTypes["default"].string
    }).isRequired,
    rebatesApplied: _propTypes["default"].shape({
      rebates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
      formattedTotalValue: _propTypes["default"].string
    }).isRequired,
    options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      addOn: _propTypes["default"].shape({
        id: _propTypes["default"].string.isRequired,
        type: _propTypes["default"].string.isRequired
      }),
      rebatesApplied: _propTypes["default"].shape({
        formattedTotalValue: _propTypes["default"].string.isRequired,
        rebates: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
        visible: _propTypes["default"].bool.isRequired
      }).isRequired
    })).isRequired
  }).isRequired,
  className: _propTypes["default"].string
};
LineItemDiscounts.defaultProps = {
  className: ''
};
var _default = LineItemDiscounts;
exports["default"] = _default;